const Title = () => {
    return (
        <div>
            <h1>Covid Tracker</h1>
            <p style={{margin: 0, lineHeight: "25px", textAlign: "center"}}>with TypeScript</p>
        </div>
    );
};

export default Title;